import React from "react";
import { useHistory } from "react-router-dom";
import { ChapterForm } from "../components/chapters/ChapterForm";
import PremiumFeatureNotice from "../components/chapters/PremiumFeatureNotice";
import { useTransporterInfo } from "../hooks/useTransporterInfo";
import { SubscriptionType } from "../interfaces/transporters.interface";

const ChapterCreation: React.FC = () => {
  const { transporterInfo } = useTransporterInfo();
  const history = useHistory();

  const handleChapterCreated = () => {
    history.push("/chapters");
  };

  if (transporterInfo.subscriptionType !== SubscriptionType.PAID) {
    return <PremiumFeatureNotice />;
  }

  return (
    <div className="flex flex-col h-[calc(100vh-70px)] bg-slate-50">
      <div className="px-12 flex flex-col h-full">
        <div className="flex-shrink-0 mb-6 flex justify-between items-center">
          <h1 className="text-3xl font-bold">Créer un nouveau chapitre</h1>
          <button
            onClick={() => history.push("/chapters")}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            <i className="ph-bold ph-arrow-left mr-2"></i>
            Retour
          </button>
        </div>
        <div className="flex-1 min-h-0">
          <div className="bg-white shadow-md rounded-lg p-6 h-full">
            <ChapterForm
              mode="create"
              onSubmitSuccess={handleChapterCreated}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterCreation;
